import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux';

import { selectIsRequestPending, requireLogin } from '../../../util/index'
import { Container } from '../../../components/index'
import UserEmulatorForm from './UserEmulatorForm'
import { clearIssues } from '../../../serviceDesk/actions'
import { checkUserExists, setUserCheckResults } from '../../../accessSelfService/actions'
import { selectUserCheckResults } from '../../../accessSelfService/reducer'
import { EmulateUser } from './actions'
import { setADandJiraUser } from '../../../auth/actions'

const description = `This tool allows you to access the Portal as a different user.
Usage: 
    1) check that the Email or ID of the user you want to emulate is valid.
    2) Emulate the user.

Notes: 
    The requests list is cleared when emulating, hit the refresh button next to the requests to get tickets.
    Refresh the page to return to accessing the portal as yourself.`

class UserEmulator extends Component {

    handleSubmit = (fieldValue) => {
        let { checkUserExists, setUserCheckResults } = this.props        
        setUserCheckResults(null)
        if (!fieldValue.UserId) {
            setUserCheckResults('You need to enter an AD or Email address to check')
        }
        else {
            checkUserExists(fieldValue.UserId)            
        }
    }

    handleEmulate = (fieldValue) => {
        let { EmulateUser, setUserCheckResults, setADandJiraUser, clearIssues } = this.props
        EmulateUser(fieldValue.UserId, setADandJiraUser, clearIssues)
        setUserCheckResults(null)
    }

    render () {
        let { userCheckResults, userEmulationPending, userCheckPending } = this.props
        return (
            <div>            
            <Container section>
                <pre className=''>
                    {description}
                </pre>
                <UserEmulatorForm 
                    onSubmit={userCheckResults === true ? this.handleEmulate : this.handleSubmit} 
                    actionInProgress={userCheckResults === true || userEmulationPending ? userEmulationPending : userCheckPending }
                    userCheckResults={userCheckResults} 
                    />
            </Container>
            </div>
        )
    }

}

export default compose(
    requireLogin('UserEmulator'),
    connect(state => {
    return {
        userEmulationPending: selectIsRequestPending(state, EmulateUser),
        userCheckPending: selectIsRequestPending(state, checkUserExists),        
        userCheckResults: selectUserCheckResults(state),
    }
  }, { checkUserExists, EmulateUser, setADandJiraUser, setUserCheckResults, clearIssues }))(UserEmulator)


// WEBPACK FOOTER //
// ./client/src/admin/tools/userEmulator/UserEmulator.js